:host {
  display: block;
  user-select: none;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  eco-suite-navbar-tooltip {
    width: 100%;
  }
}

.EcoSuiteNavbarButton {
  --button-size: 32px;
  --mobile-button-size: 40px;

  appearance: none;
  position: relative;
  outline: 0;
  border: 1px solid transparent;
  cursor: pointer;
  display: flex;
  gap: var(--pdt-space-75);
  align-items: center;
  justify-content: center;
  width: var(--button-size);
  height: var(--button-size);
  border-radius: var(--pdt-radius-100);
  color: var(--pdt-color-text);
  text-decoration: none;
  max-width: 200px;
  font-family: inherit;
  background-color: var(--pdt-color-bg-alpha-subtle);
  transition: background-color .2s ease;

  &:hover:not(:disabled) {
    background-color: var(--pdt-color-bg-alpha-subtle-hovered);
  }

  &:active:not(:disabled) {
    background-color: var(--pdt-color-bg-alpha-subtle-pressed);
  }

  &:focus-visible {
    border-color: var(--pdt-color-border-focused);
    box-shadow: var(--pdt-shadow-focus);
  }

  &:disabled {
    cursor: not-allowed;
    color: var(--pdt-color-text-disabled);
  }

  &__label {
    font-size: var(--pdt-text-body-sm-font-size);
    flex-grow: 1;
    text-align: start;
    gap: var(--pdt-space-75);
    overflow: hidden;
    display: none;

    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  &--badge {
    slot[name="icon"] {
      position: relative;

      &::after {
        content: '';
        position: absolute;
        top: 1px;
        inset-inline-start: 21px;
        width: 8px;
        height: 8px;
        background-color: var(--pdt-color-bg-accent);
        border-radius: var(--pdt-radius-full);
      }
    }
  }

  pwc-icon-shadow[icon="chevron-right"] {
    transform: rotate(90deg);
    margin-left: -2px;
  }

  &--showLabel {
    width: auto;
    padding: 0 var(--pdt-space-100);

    &.EcoSuiteNavbarButton--hasMenu {
      padding-right: var(--pdt-space-75);
    }

    .EcoSuiteNavbarButton__label {
      display: flex;
    }

    slot[name="icon"]::after {
      inset-inline-start: 24px;
    }
  }

  &--open {
    background-color: var(--pdt-color-bg-selected);
    color: var(--pdt-color-text-selected);

    &:hover,
    &:active {
      background-color: var(--pdt-color-bg-selected);
    }
  }

  &--desktopAccountMenu {
    border-radius: var(--pdt-radius-full);
    background-color: var(--pdt-color-bg-neutral-medium);
    color: var(--pdt-color-text-bold);
    margin-left: var(--pdt-space-75);

    --avatar-bg: transparent;
    --avatar-color: inherit;

    &:hover {
      background-color: var(--pdt-color-bg-neutral-medium-hovered);
      color: var(--pdt-color-text);
    }

    &:active {
      background-color: var(--pdt-color-bg-neutral-medium-pressed);
      color: var(--pdt-color-text);
    }
  }

  &--mobileMenu {
    height: var(--mobile-button-size);
    width: 100%;
    max-width: none;
    display: flex;
    padding: var(--pdt-space-100) var(--pdt-space-150);
    border-radius: var(--pdt-radius-150);
    position: static;
    gap: var(--pdt-space-150);
    justify-content: flex-start;
    overflow: hidden;

    --avatar-bg: var(--pdt-color-bg-neutral-medium);
    --avatar-color: var(--pdt-color-text-bold);

    .EcoSuiteNavbarButton__label {
      display: flex;
    }

    pwc-icon-shadow[icon="chevron-right"] {
      transform: none;
      margin-left: auto;

      :host(:dir(rtl)) & {
        transform: scaleX(-1);
      }
    }

    slot[name="icon"]::after {
      top: 6px;
      inset-inline-start: 30px;
    }
  }

  &--mobileAccountMenu {
    padding: var(--pdt-space-75) var(--pdt-space-150) var(--pdt-space-75) var(--pdt-space-100);
  }
}
